import Vue from 'vue'
import VueRouter from 'vue-router'
// views
import VLogin from '@/views/login'
import VPassword from '@/views/password'
import VNotfound from '@/views/notfound'
// views - monitor
import VMonitorIndex from '@/views/monitor/index'
import VMonitorTask from '@/views/monitor/task'
// views - order
import VOrderLayout from '@/views/order/_layout'
import VOrderError from '@/views/order/error'
import VOrderRecord from '@/views/order/record'
import VOrderWorkflow from '@/views/order/workflow'
import VOrderInquiry from '@/views/order/inquiry'
// views - inventory
import VInventoryLayout from '@/views/inventory/_layout'
import VInventoryExamination from '@/views/inventory/examination'
import VInventoryExaminationComplete from '@/views/inventory/examination-complete'
import VInventoryForecast from '@/views/inventory/forecast'
import VInventorySearch from '@/views/inventory/search'
import VInventorySearchDetail from '@/views/inventory/search-detail'
import VInventoryMonitorList from '@/views/inventory/monitor-list'
// views - purchase
import VPurchaseLayout from '@/views/purchase/_layout'
import VPurchaseCanmou from '@/views/purchase/canmou'
import VPurchasePlan from '@/views/purchase/plan'
import VPurchasePlanDetail from '@/views/purchase/plan-detail'
// views - report
import VReportLayout from '@/views/report/_layout'
import VReportDaily from '@/views/report/daily'
import VReportWeekly from '@/views/report/weekly'
import VReportMonthly from '@/views/report/monthly'
//import VRegoodsDivine from '@/views/report/goods-divine'
//import VReweatherDivine from '@/views/report/weather-divine'
//import VRefinanceDivine from '@/views/report/finance-divine'
//import VReffectscatterDivine from '@/views/report/effectscatter-divine'
//import VRetrendDivine from '@/views/report/trend-divine'
//import VRemarkerDivine from '@/views/report/marker-divine'
const VRegoodsDivine = resolve=> require(['@/views/report/goods-divine'], resolve)
const VReweatherDivine = resolve=> require(['@/views/report/weather-divine'], resolve)
const VRefinanceDivine = resolve=> require(['@/views/report/finance-divine'], resolve)
const VReffectscatterDivine = resolve=> require(['@/views/report/effectscatter-divine'], resolve)
const VRetrendDivine = resolve=> require(['@/views/report/trend-divine'], resolve)
const VRemarkerDivine = resolve=> require(['@/views/report/marker-divine'], resolve)

// views - sale
import VSaleIndex from '@/views/sale/_layout'
import VSaleForecast from '@/views/sale/sales-forecast'
// views - config
import VConfigLayout from '@/views/config/_layout'
//---+
import VConfigStrategy from '@/views/config/strategy'
import VConfigStrategy_order_group from '@/views/config/strategy/order-group'
import VConfigStrategy_order_work_flow from '@/views/config/strategy/order-work-flow'
import VConfigStrategy_order_audit_rule from '@/views/config/strategy/order-audit-rule'
import VConfigStrategy_order_merge_rule from '@/views/config/strategy/order-merge-rule'
import VConfigStrategy_order_delivery_rule from '@/views/config/strategy/order-delivery-rule'
import VConfigStrategy_order_split_rule from '@/views/config/strategy/order-split-rule'
import VConfigStrategy_order_wh_allot_rule from '@/views/config/strategy/order-wh-allot-rule'
import VConfigStrategy_return_group from '@/views/config/strategy/return-group'
import VConfigStrategy_return_audit_rule from '@/views/config/strategy/return-audit-rule'
import VConfigStrategy_return_delivery_rule from '@/views/config/strategy/return-delivery-rule'
import VConfigStrategy_retrurn_wh_allot_rule from '@/views/config/strategy/retrurn-wh-allot-rule'
import VConfigStrategy_print_order from '@/views/config/strategy/print-order'
import VConfigStrategy_print_delivery_order from '@/views/config/strategy/print-delivery-order'
import VConfigStrategy_stock_StockRule from '@/views/config/strategy/stock-rule'
//---+
import VConfigDatain from '@/views/config/data-in'
//---+
import VConfigAccount from '@/views/config/account'

Vue.use(VueRouter)

let router = new VueRouter({
    routes: [
        {path: '/', redirect: '/monitor/index'},
        {path: '/login', component: VLogin},
        {path: '/password', component: VPassword},
        // monitor
        {path: '/monitor/index', component: VMonitorIndex},
        {path: '/monitor/task', component: VMonitorTask},
        // order
        {
            path: '/order',
            component: VOrderLayout,
            redirect: '/order/error',
            children: [
                {path: '/order/error', component: VOrderError},
                {path: '/order/record', component: VOrderRecord},
                {path: '/order/workflow', component: VOrderWorkflow},
                {path: '/order/inquiry', component: VOrderInquiry}
            ]
        },
        // inventory
        {
            path: '/inventory',
            component: VInventoryLayout,
            redirect: '/inventory/examination',
            children: [
                {path: '/inventory/examination', component: VInventoryExamination},
                {path: '/inventory/examination-complete', component: VInventoryExaminationComplete},
                {path: '/inventory/forecast', component: VInventoryForecast},
                {path: '/inventory/search', component: VInventorySearch},
                {path: '/inventory/search-detail', component: VInventorySearchDetail},
                {path: '/inventory/monitor-list', component: VInventoryMonitorList},
            ]
        },
        // purchase
        {
            path: '/purchase',
            component: VPurchaseLayout,
            redirect: '/purchase/canmou',
            children: [
                {path: '/purchase/canmou', component: VPurchaseCanmou},
                {path: '/purchase/plan', component: VPurchasePlan},
                {path: '/purchase/plan-detail', component: VPurchasePlanDetail},
            ]
        },
        // report
        {
          path: '/report',
          component: VReportLayout,
          redirect: '/report/daily',
          children: [
            {path: '/report/daily', component: VReportDaily},
            {path: '/report/weekly', component: VReportWeekly},
            {path: '/report/monthly', component: VReportMonthly},
            {path: '/report/goods-divine', component: VRegoodsDivine},
            {path: '/report/weather-divine', component: VReweatherDivine},
            {path: '/report/finance-divine', component: VRefinanceDivine},
            {path: '/report/effectscatter-divine', component: VReffectscatterDivine},
            {path: '/report/trend-divine', component: VRetrendDivine},
            {path: '/report/marker-divine', component: VRemarkerDivine},
          ]
        },
        // sale
        {
          path: '/sale',
          component: VSaleIndex,
          redirect: '/sale/sales-forecast',
          children: [
            {path: '/sale/sales-forecast', component: VSaleForecast},
          ]
        },
        // config
        {
            path: '/config',
            component: VConfigLayout,
            redirect: '/config/strategy/order-group',
            children: [
                {
                    path: '/config/strategy',
                    component: VConfigStrategy,
                    redirect: '/config/strategy/order-group',
                    children: [
                        {path: 'order-group', component: VConfigStrategy_order_group},
                        {path: 'order-work-flow', component: VConfigStrategy_order_work_flow},
                        {path: 'order-audit-rule', component: VConfigStrategy_order_audit_rule},
                        {path: 'order-merge-rule', component: VConfigStrategy_order_merge_rule},
                        {path: 'order-delivery-rule', component: VConfigStrategy_order_delivery_rule},
                        {path: 'order-split-rule', component: VConfigStrategy_order_split_rule},
                        {path: 'order-wh-allot-rule', component: VConfigStrategy_order_wh_allot_rule},
                        {path: 'return-group', component: VConfigStrategy_return_group},
                        {path: 'return-audit-rule', component: VConfigStrategy_return_audit_rule},
                        {path: 'return-delivery-rule', component: VConfigStrategy_return_delivery_rule},
                        {path: 'retrurn-wh-allot-rule', component: VConfigStrategy_retrurn_wh_allot_rule},
                        {path: 'print-order', component: VConfigStrategy_print_order},
                        {path: 'print-delivery-order', component: VConfigStrategy_print_delivery_order},
                        {path: 'stock-rule', component: VConfigStrategy_stock_StockRule},
                    ]
                },
                {path: '/config/data-in', component: VConfigDatain},
                {path: '/config/account', component: VConfigAccount}
            ]
        },
        // 其他
        {path: '*', component: VNotfound}
    ]
})

export default router



// WEBPACK FOOTER //
// ./src/router.js